import { render, staticRenderFns } from "./safestock-add.vue?vue&type=template&id=07631b9e"
import script from "./safestock-add.vue?vue&type=script&lang=ts"
export * from "./safestock-add.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports